<template>
	<div v-if="currentShop.id != -1" class="search-conversation-component search-box js-search-conversation">
		<el-select v-model="searchType" @change="changeSearchType" size="mini">
			<el-option label="搜索" :value="1"></el-option>
			<el-option label="创建" :value="2"></el-option>
			<el-option label="重开" :value="3"></el-option>
		</el-select>
		<template v-if="searchType == 1">
			<input v-model="searchText" class="text" type="text" placeholder="查找联系人" @keyup.enter="clickSearch()">
			<ul v-if="typeof searchResult == 'string'" v-show="showList" v-html="searchResult" class="list"></ul>
			<ul v-else v-show="showList" class="list">
				<li v-for="obj in searchResult" :class="{'keep': obj.uncloseable}" @click="toSelectUser(obj)">
					<span :class="{thumb: true, icon: true, 'icon-wangwang': currentShop.serviceType == $store.state.TYPES.WANGWANG, 'icon-liaotian1': currentShop.serviceType != $store.state.TYPES.WANGWANG}">
						<img v-if="obj.headThumb" :src="obj.headThumb" :alt="obj.name">
					</span>
					<p class="name" :class="{'green-text': !obj.closed}">{{ obj.clientNickName }}</p>
				</li>
			</ul>
		</template>
		<template v-else-if="searchType == 3">
			<input v-model="searchText" class="text" type="text" placeholder="搜索联系人重开会话" @keyup.enter="clickSearch()">
			<ul v-if="typeof searchResult == 'string'" v-show="showList" v-html="searchResult" class="list"></ul>
			<ul v-else v-show="showList" class="list">
				<li v-for="obj in searchResult" @click="selectSearch(obj)">
					<span :class="{thumb: true, icon: true, 'icon-wangwang': currentShop.serviceType == $store.state.TYPES.WANGWANG, 'icon-liaotian1': currentShop.serviceType != $store.state.TYPES.WANGWANG}">
						<img v-if="obj.headThumb" :src="obj.headThumb" :alt="obj.name">
					</span>
					<p class="name">{{ obj.clientNickName }}</p>
				</li>
			</ul>
		</template>
		<template v-else>
			<input v-model="searchText" class="text" type="text" placeholder="输入用户id并回车创建会话" @keyup.enter="buildLiuYan()">
		</template>
		<a v-show="searchText" class="close-btn" href="javascript:;" @click="clearSearch"><span>×</span></a>
	</div>
	<div v-else class="search-box" style="margin-top: -5px">
		<el-select v-model="selectShopId" filterable placeholder="选择或搜索店铺" @change="selectShopFun" size="mini">
			<span class="icon icon-sousuo2" slot="prefix"></span>
			<el-option v-for="item in $store.state.shopList" :key="item.id" :label="item.shopName" :value="item.id"></el-option>
		</el-select>
	</div>
</template>

<script>
export default {
	name: 'searchConversation',
	data () {
		return {
			searchText: '',
			showClear: false,
			searchResult: '',
			interval: null,
			selectShopId: null,
			searchType: 1
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		showList () {
			return this.$store.state.showSearchConversationList;
		},
		conversationList () {
			return this.$store.state.conversationList;
		},
		conversationType () {
			return this.$store.state.conversationType;
		},
		userInfo () {
			return this.$store.state.userInfo
		},
		currentSessionId () {
			return this.$store.state.currentSessionId;
		}
	},
	watch: {
		searchText () {
			var self = this;
			if (self.searchType != 1 && self.searchType != 3) return;

			if (self.searchText) {
				self.$store.commit('changeShowSearchConversationList', true);
				self.searchResult = self.$store.state.loading;

				if (self.interval) clearTimeout(self.interval);
				self.interval = setTimeout(function() {
					self.submitSearchConversation();
				}, 300);
			} else {
				self.$store.commit('changeShowSearchConversationList', false);
				if (self.interval) clearTimeout(self.interval);
			}
		},
		currentShop: {
			deep: true,
			handler (now, old) {
				if (now.id == old.id) return;
				this.searchText = '';
			}
		}
	},
	methods: {
		// 切换搜索类型
		changeSearchType() {
			this.searchText = '';
			this.searchResult = '';
			this.$store.commit('changeShowSearchConversationList', false);
		},

		// 清除搜索
		clearSearch () {
			var self = this;
			self.searchText = '';
		},

		// 搜索联系人(点击搜索按钮)
		clickSearch () {
			var self = this;

			if (!self.searchText || !self.currentShop.id) return;
			if (self.interval) clearTimeout(self.interval);
			self.searchResult = self.$store.state.loading;
			self.$store.commit('changeShowSearchConversationList', true);
			self.submitSearchConversation();
		},

		// 搜索联系人
		submitSearchConversation () {
			var self = this,
				data = {
					serviceType: self.currentShop.serviceType,
					shopId: self.currentShop.id,
					sortBy: self.sortType,
					sessionOrder: self.sortType == 'startTime' ? 'asc' : 'desc',
					closed: 1,
					pageNum: 1,
					filterClientName: self.searchText
				};

			if (!self.searchText || !self.currentShop.id) return;
			self.$axios.post(API_ROOT.url + '/SessionApi.getHistorySessionList', data).then(result => {
				if (data.filterClientName != self.searchText) return;

				if (!result.status) {
					self.searchResult = '<p>' + result.msg + '</p>';
				} else {
					TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + self.currentShop.id, function(arr) {
						let a1 = arr.filter(o => o.clientNickName.includes(self.searchText))
						let nArr = a1.map(o => o.clientNickName)
						let a2 = result.data.filter(o => !nArr.includes(o.clientNickName) || o.closed)
						result.data = [...a2, ...a1]
						if (!result.data.length) {
							self.searchResult = '<p>未找到该联系人</p>';
						} else {
							self.searchResult = result.data;
						}
					})
				}
			}, response => {
				if (data.filterClientName != self.searchText) return;
				self.searchResult = '<p>服务器错误</p>';
			})
		},

		// 选中联系人(重开)
		selectSearch (obj) {
			var self = this,
				params = {
					serviceType: self.currentShop.serviceType,
					sessionId: obj.id,
					customerId: self.userInfo.id
				};

			self.searchText = '';

			if (obj.indexedDBCreateTime) {
				handle(obj)
			} else {
				self.$axios.post(API_ROOT.url + '/SessionApi.reopenSession', params).then(result => {
					if (result.status) {
						result.data.lastMsg = {msgContent: ''};
						result.data.customername = self.userInfo.real_name;
						TJ_DB.add(TJ_DB.C_Table, result.data, function(dbres) {
							if (dbres.error) {
								self.$message.error('10007: 本地数据库写入失败，请联系管理员')
							}
							handle(result.data)
						});
					} else {
						self.$alert('重开会话失败，失败原因：' + result.msg);
					}
				}, response => {
					self.$alert('重开会话失败，失败原因：网络繁忙');
				});
			}

			function handle(data) {
				TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + self.currentShop.id, function(arr) {
					arr = arr.filter(o => o.uncloseable === (data.uncloseable || false) && o.clientNickName === data.clientNickName)
					let type = data.uncloseable ? '2' : ''
					self.$store.commit('changeConversationList', arr);
					self.$store.commit('changeConversationType', type);
				})
			}
		},

		// 跳转到选中的会话(搜索)
		toSelectUser (obj) {
			var self = this,
				data = {
					serviceType: self.currentShop.serviceType,
					sessionId: obj.id,
					customerId: self.userInfo.id
				};

			self.searchText = '';

			if (obj.indexedDBCreateTime) {
				TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + self.currentShop.id, function(arr) {
					arr = arr.filter(o => o.uncloseable === (obj.uncloseable || false) && o.clientNickName === obj.clientNickName)
					let type = obj.uncloseable ? '2' : ''
					self.$store.commit('changeConversationType', type);
					self.$store.commit('changeConversationList', arr);
				})
			} else {
				var type = localStorage.getItem('IMSort') || 'startTime'
				var data = {
						serviceType: self.currentShop.serviceType,
						shopId: self.currentShop.id,
						sessionOrder: type == 'startTime' ? 'asc' : 'desc',
						sortBy: type,
						closed: 1,
						filterClientName: obj.clientNickName,
						uncloseable: obj.uncloseable || false
					};

				self.$store.commit('changeConversationType', obj.uncloseable ? '2' : '1');
				self.$store.commit('changeConversationLoadStatus', true);
				self.$store.commit('changeConversationList', []);

				self.$axios.post(API_ROOT.url + '/SessionApi.getSessionList', data).then(result => {
					if (result.status) {
						self.$store.commit('changeConversationList', result.data);
					} else {
						self.$message.error('查询会话失败，错误原因：' + result.msg);
					}
					self.$store.commit('changeConversationLoadStatus', false);
				}, response => {
					self.$message.error('查询会话失败，错误码(' + response + ')');
					self.$store.commit('changeConversationLoadStatus', false);
				})
			}
		},

		// 主动留言
		buildLiuYan () {
			var self = this,
				data = {
					serviceType: self.currentShop.serviceType,
					shopId: self.currentShop.id,
					customerId: self.userInfo.id,
					inputString: self.searchText
				};

			if (/\D/.test(self.searchText)) {
				self.$message.error('请输入数字')
				return;
			}

			self.searchText = '';

			self.$axios.post(API_ROOT.url + '/SessionApi.newSession', data).then(result => {
				if (result.status) {
					result.data.lastMsg = {msgContent: ''};
					result.data.customername = self.userInfo.real_name;
					TJ_DB.add(TJ_DB.C_Table, result.data, function(dbres) {
						if (dbres.error) {
							self.$message.error('10008: 本地数据库写入失败，请联系管理员')
						}
						TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + self.currentShop.id, function(arr) {
							self.$store.commit('changeConversationList', arr);
							self.$store.commit('changeConversationType', '');
						})
					});
				} else {
					self.$alert('新建会话失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('新建会话失败，失败原因：网络繁忙');
			});
		},

		// 离线消息里选择店铺
		selectShopFun (shopId) {
			var self = this;

			if (!shopId) return;
			self.$parent.$refs.conversationList.reSetData();
			for (var i = 0; i < self.$store.state.shopList.length; i++) {
				if (self.$store.state.shopList[i].id == shopId) {
					var item = self.$store.state.shopList[i],
						data = {
							serviceType: item.serviceType,
							shopId: item.id
						};

					
					self.currentShop.serviceType = data.serviceType;
					self.currentShop.selectObj = item;
					self.$store.commit('changeCurrentShop', self.currentShop);

					self.$store.commit('changeConversationLoadStatus', true);
					self.$axios.post(API_ROOT.url + '/SessionApi.getExpiredOfflineSessionList', data).then(result => {
						if (data.shopId != self.selectShopId || self.currentShop.id != -1) return;
						
						if (result.status) {
							self.$store.commit('changeConversationList', result.data);
						} else {
							self.$alert('获取会话列表失败，失败原因：' + result.msg);
						}
						self.$store.commit('changeConversationLoadStatus', false);
					}, response => {
						self.$alert('获取会话列表失败，错误码(' + response + ')');
						self.$store.commit('changeConversationLoadStatus', false);
					});

					break;
				}
			}
		}
	}
}
</script>
<style>
.qiehuan-btn {
	position: absolute;
    top: -1px;
    left: 1px;
    color: #1989fa;
    line-height: 22px;
    font-size: 13px;
    transform: rotate(90deg);
}
.search-conversation-component {
	display: flex;
	align-items: center;
	padding: 0 !important;
}
.search-conversation-component input.text {
	flex: 1;
	width: calc(100% - 49px);
	border: 1px solid #e8e8e8 !important;
	padding: 0 5px !important;
	height: 24px !important;
	border-top-left-radius: 0 !important;
	border-bottom-left-radius: 0 !important;
}
.search-conversation-component .el-select {
	z-index: 1;
	left: 1px;
	width: 49px;
	flex-shrink: 0;
	line-height: 22px;
}
.search-conversation-component .el-select .el-input__inner {
	height: 24px;
	padding-left: 3px;
	padding-right: 20px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
.search-conversation-component .el-select .el-input__icon {
	width: 14px;
	line-height: 1;
}
</style>
<style lang="less" scoped>
	.blue-text {
		color: #409eff !important;
	}
	.green-text {
		color: #1ad372 !important;
	}
	.keep:after {
		position: absolute;
		top: 50%;
		right: 10px;
		z-index: 1;
		transform: translateY(-50%);
		color: #72ccff;
		font-family: "iconfont" !important;
		content: '\e610' !important;
	}
</style>


// WEBPACK FOOTER //
// src/pages/conversation/searchConversation.vue